module.exports = __webpack_public_path__ + "static/instagram-8212f787e806a528e17cc8e7a1cc225d.svg";